import { render, staticRenderFns } from "./BucketSortOption.vue?vue&type=template&id=645f2483&"
import script from "./BucketSortOption.vue?vue&type=script&lang=js&"
export * from "./BucketSortOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports